var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.387 43.17c-3.812 0-6.936 3.093-6.936 6.934a6.935 6.935 0 1 0 6.935-6.935zm.248-34.8c-1.192-.127-14.16-1.03-18.73-1.386-1.907-.148-3.313.415-4.271 1.386-1.096 1.112-1.606 2.759-1.606 4.49H44.07c0-3.091-2.49-4.176-5.434-4.49zM52.74 12.77a2.376 2.376 0 0 0-2.844-.946c-.377.143-.207.073-5.794 3.63h-30.84a2.372 2.372 0 0 0-2.336 2.794 2.374 2.374 0 0 0 2.335 1.955h1.267L20.1 51.78a4.312 4.312 0 0 0 4.247 3.564h6.503a9.13 9.13 0 0 1-1.648-5.24c0-5.042 4.106-9.185 9.186-9.185 1.78 0 3.535.518 5.048 1.517l2.051-22.234 6.527-4.154a2.375 2.375 0 0 0 .728-3.279z",
    fill: "#ff4141",
    className: "fill-565d64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.83b62949ec3cce5e87546c1dee48323b.svg";
export { ForwardRef as ReactComponent };